import { connect } from 'react-redux'
import * as qs from 'utils/querystring'

import App from './App'

const getPromoCode = (querystring = '') => {
  const queryobject = qs.parse(querystring)
  return queryobject.promo_code
}

const mapStateToProps = (state, ownProps) => {
  const promoCode = getPromoCode(ownProps.location.search)
  return {
    error: state.error,
    promoCode
  }
}

const mapDispatchToProps = {
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/screens/App/AppContainer.js